import { CarrierViewRequest } from '../../api/admin-api';

export function AdminPagination({ page, pageSize, totalCount, onPageChange }: {
    page: number; pageSize: number; totalCount: number; onPageChange: (p: number) => void;
}) {
    const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
    const from = totalCount === 0 ? 0 : ((page - 1) * pageSize) + 1;
    const to = Math.min(page * pageSize, totalCount);
    return (
        <div className="admin-pager">
            <span>Showing {from}–{to} of {totalCount}</span>
            <div className="admin-pager-btns">
                <button type="button" className="admin-btn admin-btn-sm" onClick={() => onPageChange(page - 1)} disabled={page <= 1}>Previous</button>
                <span>Page {page} of {totalPages}</span>
                <button type="button" className="admin-btn admin-btn-sm" onClick={() => onPageChange(page + 1)} disabled={page >= totalPages}>Next</button>
            </div>
        </div>
    );
}

export function SortableHeader({ label, column, params, onSort }: {
    label: string; column: string; params: CarrierViewRequest; onSort: (col: string) => void;
}) {
    const isActive = params.sortBy === column;
    const arrow = isActive ? (params.sortDirection === 'asc' ? ' ▲' : ' ▼') : '';
    return (
        <th className={`sortable${isActive ? ' sorted' : ''}`} onClick={() => onSort(column)}>
            {label}{arrow}
        </th>
    );
}

export function StatusBadge({ active }: { active: boolean }) {
    return <span className={`admin-badge ${active ? 'admin-badge-on' : 'admin-badge-off'}`}>{active ? 'Active' : 'Inactive'}</span>;
}
